import React from 'react'

function Comptroller() {
  return (
    <div>
      Yo
    </div>
  )
}

export default Comptroller
